import styled from "styled-components";

const ButtonsBulkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  width: 100%;
`;

export default ButtonsBulkContainer;
